import { render } from "./CoverageMap.vue?vue&type=template&id=30b5d2ee"
import script from "./CoverageMap.vue?vue&type=script&lang=js"
export * from "./CoverageMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__